import { PopoverContent } from "./content";
import { PopoverRoot } from "./popover";
import { PopoverToggle } from "./toggle";

export const Popover = Object.assign(PopoverRoot, {
  Toggle: PopoverToggle,
  Content: PopoverContent,
});
